import { BffApiClientMolecule } from "@/app/api-client/store"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { getBlogSpotlightQueryParams } from "./get-blog-spotlight-query-params"

export function useBlogSpotlight() {
  const apiClient = useMolecule(BffApiClientMolecule)
  const queryParams = useMemo(
    () => getBlogSpotlightQueryParams(apiClient),
    [apiClient],
  )
  const queryResult = useSuspenseQuery(queryParams)

  return queryResult.data
}
